import { Form, Modal } from 'antd'
import { useEffect, useRef, useState } from 'react'

import { CloseCircleOutlined } from '@ant-design/icons'
import ColorList from 'constants/color.constants'
import styled from 'styled-components'

import { deleteCompany } from 'api/Admin/company'
import { deleteDataGroupORCategory, deleteStrategicImperative } from 'api/Admin/group'
import { deletePowerBI } from 'api/Admin/powerbi'
import { deleteRolepermission } from 'api/Admin/rolePermission'
import { deleteDataProfessionalskill } from 'api/Admin/skill'
import { deleteDataSupportCategory } from 'api/Admin/support'
import { deleteUnitmeasurment } from 'api/Admin/unitmeasurment'
import { deleteBusiness } from 'api/MasterData/business'
import { getCheckUsed } from 'api/MasterData/company'
import { deleteAdfs } from 'api/MasterData/custumAdfs'
import { deleteImpactType } from 'api/MasterData/impactType'
import { deleteKpitype } from 'api/MasterData/kpitype'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
let titleText = ''
let desText = ''
let text_state_cant_delete_title = ''
let text_state_cant_delete_des = ''
const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const PROJECT_USAGE_BLOCK_MESSAGE =
  'Cannot delete because this item is used by a project'

const isProjectUsageBlocked = (response) =>
  response?.status === 400 &&
  (response?.data?.message === PROJECT_USAGE_BLOCK_MESSAGE ||
    response?.message === PROJECT_USAGE_BLOCK_MESSAGE)

const showProjectUsageBlockedModal = (
  setVisibleCanDelete,
  setVisibleCantDelete,
) => {
  setVisibleCanDelete(false)
  setVisibleCantDelete(true)
}

const deleteRow = (props) => {
  const {
    visibleDelete,
    setVisibleDelete,
    state,
    data,
    renderData,
    setVisibleDrawer,
    //company
    setCheckChangeTable,
    setCheckRenderDelete,
    callTable,
  } = props
  // console.log(visibleDelete, data)
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const [visibleCanDelete, setVisibleCanDelete] = useState(false)
  const [visibleCantDelete, setVisibleCantDelete] = useState(false)
  const deleteConfirmedRef = useRef(false)
  const [form] = Form.useForm()
  switch (state) {
    case 'unitmeasurment':
      ;(titleText = 'delete_unitmeasurment_title'),
        (desText = 'delete_unitmeasurment_des'),
        (text_state_cant_delete_title = 'cant_delete_unit_title'),
        (text_state_cant_delete_des = 'cant_delete_unit_des')
      break
    case 'impacttype':
      ;(titleText = 'delete_project_impacttype_title'),
        (desText = 'delete_project_impacttype_des'),
        (text_state_cant_delete_title = 'cant_delete_impacttype_title'),
        (text_state_cant_delete_des = 'cant_delete_impacttype_des')
      break
    case 'company':
      ;(titleText = 'delete_company_title'),
        (desText = 'delete_company_des'),
        (text_state_cant_delete_title = 'cant_delete_company_title'),
        (text_state_cant_delete_des = 'cant_delete_company_des')
      break
    case 'operation':
      ;(titleText = 'delete_operation_title'),
        (desText = 'delete_operation_des'),
        (text_state_cant_delete_title = 'cant_delete_operation_title'),
        (text_state_cant_delete_des = 'cant_delete_operation_des')
      break
    case 'sub_operation':
      ;(titleText = 'delete_sub_operation_title'),
        (desText = 'delete_sub_operation_des'),
        (text_state_cant_delete_title = 'cant_delete_sub_operation_title'),
        (text_state_cant_delete_des = 'cant_delete_sub_operation_des')
      break
    case 'project_group':
      ;(titleText = 'delete_project_group_title'),
        (desText = 'delete_project_group_des'),
        (text_state_cant_delete_title = 'cant_delete_project_group_title'),
        (text_state_cant_delete_des = 'cant_delete_project_group_des')
      break
    case 'project_cat':
      ;(titleText = 'delete_project_cat_title'),
        (desText = 'delete_project_cat_des'),
        (text_state_cant_delete_title = 'cant_delete_project_cat_title'),
        (text_state_cant_delete_des = 'cant_delete_project_cat_des')
      break
    case 'strategic_imperative':
      ;(titleText = 'delete_strategic_imperative_title'),
        (desText = 'delete_strategic_imperative_des'),
        (text_state_cant_delete_title = 'cant_delete_strategic_imperative_title'),
        (text_state_cant_delete_des = 'cant_delete_strategic_imperative_des')
      break
    case 'support_category':
      ;(titleText = 'delete_support_cat_title'),
        (desText = 'delete_support_cat_des'),
        (text_state_cant_delete_title = 'cant_delete_support_cat_title'),
        (text_state_cant_delete_des = 'cant_delete_support_cat_des')
      break
    case 'professional_skill':
      ;(titleText = 'delete_project_profess_title'),
        (desText = 'delete_project_profess_des'),
        (text_state_cant_delete_title = 'cant_delete_project_profess_title'),
        (text_state_cant_delete_des = 'cant_delete_project_profess_des')
      break
    case 'business_unit':
      ;(titleText = 'delete_bu_title'),
        (desText = 'delete_bu_des'),
        (text_state_cant_delete_title = 'cant_delete_bu_title'),
        (text_state_cant_delete_des = 'cant_delete_bu_des')
      break
    case 'kpitype':
      ;(titleText = 'delete_kpi_title'),
        (desText = 'delete_kpi_des'),
        (text_state_cant_delete_title = 'cant_delete_kpi_title'),
        (text_state_cant_delete_des = 'cant_delete_kpi_des')
      break
    case 'rolepermission':
      ;(titleText = 'delete_role_title'),
        (desText = 'delete_role_des'),
        (text_state_cant_delete_title = 'cant_delete_role_title'),
        (text_state_cant_delete_des = 'cant_delete_role_des')
      break
    case 'powerBI':
      ;(titleText = 'delete_powerbi_title'),
        (desText = 'delete_powerbi_des'),
        (text_state_cant_delete_title = 'cant_delete_powerbi_title'),
        (text_state_cant_delete_des = 'cant_delete_powerbi_des')
      break
    case 'auth_adfs':
      ;(titleText = 'delete_auth_adfs_title'),
        (desText = 'delete_auth_adfs_adfs'),
        (text_state_cant_delete_title = 'cant_delete_auth_adfs_title'),
        (text_state_cant_delete_des = 'cant_delete_auth_adfs')
      break
    default:
      break
  }

  const getResultCheckUsed = async (state) => {
    let code = ''
    let stateURL = ''
    switch (state) {
      case 'unitmeasurment':
        stateURL = 'unittype'
        code = data.unit_code
        break
      case 'impacttype':
        stateURL = state
        code = data.impact_code
        break
      case 'company':
        stateURL = state
        code = data.code
        break
      case 'operation':
        stateURL = 'company'
        code = data.code
        break
      case 'sub_operation':
        stateURL = 'company'
        code = data.code
        break
      case 'project_group':
        stateURL = 'projectgroup'
        code = data.code
        break
      case 'project_cat':
        stateURL = 'projectgroup'
        code = data.code
        break
      case 'support_category':
        stateURL = 'supporttype'
        code = data.code
        break
      case 'professional_skill':
        stateURL = 'professionalskill'
        code = data.code
        break
      case 'business_unit':
        stateURL = 'businessunit'
        code = data.business_code
        break
      case 'kpitype':
        stateURL = 'kpitype'
        code = data.kpi_code
        break
      case 'rolepermission':
        stateURL = 'role'
        code = ''
        break
      case 'powerBI':
        stateURL = 'powerbi'
        code = data.code
        break
      case 'auth_adfs':
        stateURL = state
        code = ''
        break
      default:
        break
    }
    const dataObj = {
      state: stateURL,
      id: data.id,
      code: code,
    }
    await getCheckUsed({
      params: dataObj,
      token: token,
    })
      .then(async (response) => {
        if (deleteConfirmedRef.current) {
          return
        }
        const { status, data, error } = response
        if (error) {
          // setData([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          if (data.used === true) {
            setVisibleCanDelete(false)
            setVisibleCantDelete(true)
          } else {
            setVisibleCanDelete(true)
          }
          setIsLoading(false)
        } else {
          // setData([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        // setData([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (!visibleDelete) {
      deleteConfirmedRef.current = false
      setVisibleCanDelete(false)
      setVisibleCantDelete(false)
      return
    }

    if (state === 'powerBI' || state === 'strategic_imperative') {
      setVisibleCanDelete(true)
      return
    }

    getResultCheckUsed(state)
  }, [visibleDelete])

  const onOk = () => {
    deleteConfirmedRef.current = true
    console.log('debug', state)

    if (state == 'unitmeasurment') {
      if (data.id > 6) {
        try {
          deleteUnitmeasurment({
            id: data.id,
            code: data.unit_code,
            token: token,
          }).then((response) => {
            if (response.status === 200) {
              setVisibleDelete(false)
              setVisibleDrawer(false)
              setVisibleCanDelete(false)
              renderData()
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    } else if (state == 'company' || state == 'operation' || state == 'sub_operation') {
      if (data.id == 1 || data.id == 2) {
      } else {
        // console.log(data)
        try {
          deleteCompany({
            params: '',
            token: token,
            idCompany: data.id,
            code: data.code,
          }).then((response) => {
            if (response.status === 200) {
              setVisibleDelete(false)
              setVisibleDrawer(false)
              renderData()
              setCheckChangeTable(9998)
              setCheckRenderDelete(true)
              setVisibleCanDelete(false)
            } else if (isProjectUsageBlocked(response)) {
              showProjectUsageBlockedModal(
                setVisibleCanDelete,
                setVisibleCantDelete,
              )
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    } else if (state === 'project_group' || state === 'project_cat') {
      const inBacole = {
        id: data.id,
        code: data.code,
        state: state,
      }
      try {
        deleteDataGroupORCategory({
          params: inBacole,
          token: token,
        }).then((res) => {
          console.log(res)
          if (res.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
            callTable()
          } else if (isProjectUsageBlocked(res)) {
            showProjectUsageBlockedModal(
              setVisibleCanDelete,
              setVisibleCantDelete,
            )
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'impacttype') {
      if (data.id > 2) {
        try {
          deleteImpactType({
            token: token,
            id: data.id,
            code: data.impact_code,
          }).then((response) => {
            if (response.status === 200) {
              setCheckChangeTable(9998)
              setVisibleDelete(false)
              setVisibleDrawer(false)
              setVisibleCanDelete(false)
              renderData()
            } else if (isProjectUsageBlocked(response)) {
              showProjectUsageBlockedModal(
                setVisibleCanDelete,
                setVisibleCantDelete,
              )
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    } else if (state === 'support_category') {
      // console.log(data)
      try {
        deleteDataSupportCategory({
          token: token,
          id: data.id,
          code: data.code,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'professional_skill') {
      try {
        deleteDataProfessionalskill({
          token: token,
          id: data.id,
          code: data.code,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'strategic_imperative') {
      try {
        deleteStrategicImperative({
          params: {
            id: data.imperative_id,
          },
          token: token,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
            callTable()
          } else if (isProjectUsageBlocked(response)) {
            showProjectUsageBlockedModal(
              setVisibleCanDelete,
              setVisibleCantDelete,
            )
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'business_unit') {
      try {
        deleteBusiness({
          token: token,
          id: data.id,
          code: data.business_code,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'kpitype') {
      try {
        deleteKpitype({
          token: token,
          id: data.id,
          code: data.kpi_code,
        }).then((response) => {
          console.log(response)
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
            setCheckChangeTable(9998)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'rolepermission') {
      try {
        deleteRolepermission({
          token: token,
          id: data.id,
        }).then((response) => {
          console.log(response)
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'auth_adfs') {
      try {
        deleteAdfs({
          token: token,
          id: data.id,
        }).then((response) => {
          console.log(response)
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state === 'powerBI') {
      try {
        deletePowerBI({
          token: token,
          id: data.id,
          code: data.code,
        }).then((response) => {
          const { status, data, error } = response
          if (status === 200) {
            setVisibleDelete(false)
            setVisibleDrawer(false)
            setVisibleCanDelete(false)
            renderData()
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onCancleDelete = () => {
    setVisibleCanDelete(false)
    setVisibleDelete(false)
  }
  const onCancleCantDelete = () => {
    setVisibleCantDelete(false)
    setVisibleDelete(false)
  }
  return (
    <>
      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={visibleCanDelete}
        okText={'Delete'}
        onOk={() => onOk()}
        onCancel={onCancleDelete}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word[titleText]}</h2>
        <h4>{word[desText]}</h4>
      </Modal>

      <Modal
        maskClosable={false}
        className="DeleteModal edit-size-modal-delete"
        visible={visibleCantDelete}
        onCancel={onCancleCantDelete}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word[text_state_cant_delete_title]}</h2>
        <h4>{word[text_state_cant_delete_des]}</h4>
      </Modal>
    </>
  )
}
export default deleteRow
